module.exports = __webpack_public_path__ + "img/EQULIZER.ead9eb20.svg";